import BrowserView from './BrowserView';

export default BrowserView;
